import { z } from 'zod';
import { itemGeo } from '../geo/zod.js';

z.string().min(8).max(9);
z.string().min(8).max(9);
const itemURN = z.custom((val) => typeof val === 'string'
    ? /^id:ad:(.{36}|\d{8,9}):list:\d{8,9}$/.test(val)
    : false);
const price = z.number().int().min(0);
var MacroCategoryID;
(function (MacroCategoryID) {
    MacroCategoryID["Tutte"] = "0";
    MacroCategoryID["Motori"] = "1";
    MacroCategoryID["Immobili"] = "6";
    MacroCategoryID["LavoroServizi"] = "24";
    MacroCategoryID["Elettronica"] = "9";
    MacroCategoryID["CasaPersona"] = "13";
    MacroCategoryID["SportsHobby"] = "18";
    MacroCategoryID["Altri"] = "27";
})(MacroCategoryID || (MacroCategoryID = {}));
var LeafCategoryID;
(function (LeafCategoryID) {
    LeafCategoryID["Auto"] = "2";
    LeafCategoryID["AccessoriAuto"] = "5";
    LeafCategoryID["Moto"] = "3";
    LeafCategoryID["AccessoriMoto"] = "36";
    LeafCategoryID["Nautica"] = "22";
    LeafCategoryID["CaravanECamper"] = "34";
    LeafCategoryID["VeicoliCommerciali"] = "4";
    LeafCategoryID["Appartamenti"] = "7";
    LeafCategoryID["CamerePostiLetto"] = "43";
    LeafCategoryID["Ville"] = "29";
    LeafCategoryID["TerreniRustici"] = "30";
    LeafCategoryID["GarageBox"] = "31";
    LeafCategoryID["LoftMansarde"] = "32";
    LeafCategoryID["CaseVacanza"] = "33";
    LeafCategoryID["UfficiLocali"] = "8";
    LeafCategoryID["OfferteLavoro"] = "26";
    LeafCategoryID["Servizi"] = "50";
    LeafCategoryID["Candidati"] = "42";
    LeafCategoryID["Attrezzature"] = "25";
    LeafCategoryID["Informatica"] = "10";
    LeafCategoryID["ConsoleVideogiochi"] = "44";
    LeafCategoryID["AudioVideo"] = "11";
    LeafCategoryID["Fotografia"] = "40";
    LeafCategoryID["Telefonia"] = "12";
    LeafCategoryID["ArredamentoCasalinghi"] = "14";
    LeafCategoryID["Elettrodomestici"] = "37";
    LeafCategoryID["GiardinoFaiDaTe"] = "15";
    LeafCategoryID["AbbigliamentoAccessori"] = "16";
    LeafCategoryID["TuttoBambini"] = "17";
    LeafCategoryID["Animali"] = "23";
    LeafCategoryID["AccessoriAnimali"] = "100";
    LeafCategoryID["MusicaFilm"] = "19";
    LeafCategoryID["LibriRiviste"] = "38";
    LeafCategoryID["StrumentiMusicali"] = "39";
    LeafCategoryID["Sports"] = "20";
    LeafCategoryID["Biciclette"] = "41";
    LeafCategoryID["Collezionismo"] = "21";
    LeafCategoryID["AltriAnnunci"] = "28";
})(LeafCategoryID || (LeafCategoryID = {}));
const CategoryID = { ...MacroCategoryID, ...LeafCategoryID };
var AdTypes;
(function (AdTypes) {
    AdTypes["Sell"] = "s";
    AdTypes["Seek"] = "k";
    AdTypes["Rent"] = "u";
    AdTypes["VacationRent"] = "h";
    AdTypes["GiveAway"] = "g";
})(AdTypes || (AdTypes = {}));
const keyValuePair = z.object({
    key: z.string(),
    value: z.string(),
    weight: z.number().optional(),
    label: z.string().optional(),
    level: z.number().optional(),
    description: z.string().optional(),
});
const adTypeKeyValue = keyValuePair.merge(z.object({
    key: z.nativeEnum(AdTypes),
}));
var FeatureURI;
(function (FeatureURI) {
    FeatureURI["AdType"] = "/type";
    FeatureURI["AdvertiserType"] = "/advertiser_type";
    FeatureURI["AirConditioning"] = "/air_conditioning";
    FeatureURI["AllServicings"] = "/all_servicings";
    FeatureURI["AnimalType"] = "/animal_type";
    FeatureURI["AudiovideoType"] = "/audiovideo_type";
    FeatureURI["AvailableNow"] = "/available_now";
    FeatureURI["Balcony"] = "/balcony";
    FeatureURI["Bathrooms"] = "/bathrooms";
    FeatureURI["BicycleType"] = "/bicycle_type";
    FeatureURI["Bike"] = "/bike";
    FeatureURI["BookType"] = "/book_type";
    FeatureURI["Brand"] = "/brand";
    FeatureURI["BuildingCondition"] = "/building_condition";
    FeatureURI["Car"] = "/car";
    FeatureURI["CaravanType"] = "/caravan_type";
    FeatureURI["CarType"] = "/car_type";
    FeatureURI["Category"] = "/category";
    FeatureURI["CategoryFacet"] = "/category_facet";
    FeatureURI["ChildrenAge"] = "/children_age";
    FeatureURI["ChildrenType"] = "/children_type";
    FeatureURI["Cin"] = "/cin";
    FeatureURI["ClothingGender"] = "/clothing_gender";
    FeatureURI["ClothingNumber"] = "/clothing_number";
    FeatureURI["ClothingType"] = "/clothing_type";
    FeatureURI["Color"] = "/color";
    FeatureURI["ComputerType"] = "/computer_type";
    FeatureURI["Consumption"] = "/consumption";
    FeatureURI["ConsumptionSearchable"] = "/consumption_searchable";
    FeatureURI["ContractType"] = "/contract_type";
    FeatureURI["CubicCapacity"] = "/cubic_capacity";
    FeatureURI["Damaged"] = "/damaged";
    FeatureURI["Degree"] = "/degree";
    FeatureURI["Doors"] = "/doors";
    FeatureURI["DriveWheel"] = "/drive_wheel";
    FeatureURI["Elevator"] = "/elevator";
    FeatureURI["EnergyClass"] = "/energy_class";
    FeatureURI["EnginePower"] = "/engine_power";
    FeatureURI["Equipment"] = "/equipment";
    FeatureURI["Floor"] = "/floor";
    FeatureURI["Fuel"] = "/fuel";
    FeatureURI["Furnished"] = "/furnished";
    FeatureURI["Garden"] = "/garden";
    FeatureURI["Gearbox"] = "/gearbox";
    FeatureURI["Gender"] = "/gender";
    FeatureURI["Heating"] = "/heating";
    FeatureURI["HobbyType"] = "/hobby_type";
    FeatureURI["HorsePower"] = "/horsepower";
    FeatureURI["IsRental"] = "/is_rental";
    FeatureURI["ItemShippable"] = "/item_shippable";
    FeatureURI["ItemShippingCost"] = "/item_shipping_cost";
    FeatureURI["ItemShippingCostTuttoSubito"] = "/item_shipping_cost_tuttosubito";
    FeatureURI["ItemShippingPackageSize"] = "/item_shipping_package_size";
    FeatureURI["ItemShippingAllowed"] = "/item_shipping_allowed";
    FeatureURI["ItemShippingType"] = "/item_shipping_type";
    FeatureURI["ItemCondition"] = "/item_condition";
    FeatureURI["JobCategory"] = "/job_category";
    FeatureURI["LastFloor"] = "/last_floor";
    FeatureURI["Mileage"] = "/mileage";
    FeatureURI["MileageScalar"] = "/mileage_scalar";
    FeatureURI["Model"] = "/model";
    FeatureURI["MonthlyRent"] = "/monthly_rent";
    FeatureURI["MotorbicycleType"] = "/motorbicycle_type";
    FeatureURI["MultiLevel"] = "/multi_level";
    FeatureURI["Name"] = "/name";
    FeatureURI["NoSalesman"] = "/nosalesman";
    FeatureURI["OfficeType"] = "/office_type";
    FeatureURI["PaintType"] = "/paint_type";
    FeatureURI["Parking"] = "/parking";
    FeatureURI["PhoneType"] = "/phone_type";
    FeatureURI["Pollution"] = "/pollution";
    FeatureURI["Power"] = "/power";
    FeatureURI["Price"] = "/price";
    FeatureURI["Promotions"] = "/promotions";
    FeatureURI["QualitySeal"] = "/quality_seal";
    FeatureURI["QualitySealFlag"] = "/quality_seal_flag";
    FeatureURI["Reception"] = "/reception";
    FeatureURI["RegisterDate"] = "/register_date";
    FeatureURI["RegisterMonth"] = "/month";
    FeatureURI["RegMonth"] = "/regmonth";
    FeatureURI["Room"] = "/room";
    FeatureURI["Rooms"] = "/rooms";
    FeatureURI["RoomType"] = "/room_type";
    FeatureURI["Seats"] = "/seats";
    FeatureURI["Service"] = "/service";
    FeatureURI["ServiceType"] = "/service_type";
    FeatureURI["ShipLength"] = "/ship_length";
    FeatureURI["ShipType"] = "/ship_type";
    FeatureURI["Size"] = "/size";
    FeatureURI["SmokeFree"] = "/smoke_free";
    FeatureURI["Smoker"] = "/smoker";
    FeatureURI["ShippingCarriers"] = "/shipping_carriers";
    FeatureURI["SportType"] = "/sport_type";
    FeatureURI["TransactionStatus"] = "/transaction_status";
    FeatureURI["TotalOwners"] = "/total_owners";
    FeatureURI["UserId"] = "/user_id";
    FeatureURI["VatDeductible"] = "/vat_deductible";
    FeatureURI["VehicleLength"] = "/vehicle_length";
    FeatureURI["VehicleStatus"] = "/vehicle_status";
    FeatureURI["VehicleType"] = "/vehicle_type";
    FeatureURI["VehicleHeight"] = "/vehicle_height";
    FeatureURI["VehicleWidth"] = "/vehicle_width";
    FeatureURI["Version"] = "/version";
    FeatureURI["WarrantyMonths"] = "/warranty_months";
    FeatureURI["WorkHours"] = "/work_hour";
    FeatureURI["WorkLevel"] = "/work_level";
    FeatureURI["Year"] = "/year";
    FeatureURI["FashionClothingType"] = "/fashion/clothing_type";
    FeatureURI["FashionBrand"] = "/fashion/brand";
    FeatureURI["FashionSize"] = "/fashion/size";
})(FeatureURI || (FeatureURI = {}));
const itemFeature = z.object({
    uri: z.nativeEnum(FeatureURI),
    type: z.string(),
    label: z.string(),
    values: z.array(keyValuePair),
});
const itemImage = z.object({
    cdnBaseUrl: z.string(),
});
const itemCategory = z.object({
    id: z.nativeEnum(LeafCategoryID),
    label: z.string(),
    parentId: z.nativeEnum(MacroCategoryID),
    friendlyName: z.string(),
    weight: z.number(),
});
const itemFeatures = z.record(z.nativeEnum(FeatureURI), itemFeature);
const itemVisibilityOptions = z.object({
    gallery: z.boolean(),
    urgent: z.boolean(),
    smartbumpedAt: z.string().optional(),
    bounce: z.boolean().optional(),
    autoBounce: z.boolean().optional(),
    geoBoost: z.string().optional(),
    morePhotos: z.boolean().optional(),
    homepageRecommender: z.boolean().optional(),
    detailRecommender: z.boolean().optional(),
});
var AdvertiserType;
(function (AdvertiserType) {
    AdvertiserType[AdvertiserType["Private"] = 0] = "Private";
    AdvertiserType[AdvertiserType["Pro"] = 1] = "Pro";
    AdvertiserType[AdvertiserType["Company"] = 2] = "Company";
})(AdvertiserType || (AdvertiserType = {}));
const itemAdvertiser = z.object({
    company: z.boolean(),
    name: z.string(),
    phone: z.string().optional(),
    type: z.nativeEnum(AdvertiserType),
    userId: z.string(),
    shopId: z.string().optional(),
    shopName: z.string().optional(),
    proTransactionsEnabled: z.boolean().optional(),
    proPremiumDetailEnabled: z.boolean().optional(),
});
const adItem = z.object({
    kind: z.literal('AdItem'),
    urn: itemURN,
    type: adTypeKeyValue,
    category: itemCategory,
    subject: z.string(),
    body: z.string(),
    date: z.string(),
    images: z.array(itemImage),
    features: itemFeatures,
    advertiser: itemAdvertiser,
    geo: itemGeo,
    urls: z.object({ default: z.string(), mobile: z.string() }),
    gallerized: z.boolean().optional(),
    visibilityOptions: itemVisibilityOptions.optional(),
});
const adOwnerVerification = z.object({
    userID: z.string().optional(),
    listID: z.string().optional(),
    isOwner: z.boolean().optional(),
});
const correlatedTrackingInfo = z.object({
    transactionID: z.string(),
    listName: z.string(),
    itemID: z.string(),
});
const correlatedAdsIds = z.object({
    ids: z.array(itemURN),
    trackingInfo: correlatedTrackingInfo.optional(),
});
const userAdStatistics = z.object({
    position: z.number(),
    messages: z.number(),
    views: z.number(),
});
const userAd = adItem.merge(z.object({
    editUrl: z.string().optional(),
    expiresIn: z.number().optional(),
    statistics: userAdStatistics.optional(),
    paidOptions: z.array(z.object({ id: z.string() })).optional(),
}));
const searchExtras = z.object({
    advertiserTypeFacets: z.record(z.string(), z.string()).optional(),
});
const userAds = z.object({
    total: z.number(),
    checkNew: z.string(),
    lines: z.number(),
    start: z.number(),
    extras: searchExtras.optional(),
    filterLabels: z.record(z.string(), z.string()).optional(),
    ads: z.array(userAd),
});
const deleteReason = z.object({
    key: z.string(),
    value: z.string(),
});
const deleteReasons = z.object({
    uri: z.string(),
    label: z.string(),
    values: z.array(deleteReason),
});

export { AdTypes, AdvertiserType, CategoryID, FeatureURI, LeafCategoryID, MacroCategoryID, adItem, adOwnerVerification, adTypeKeyValue, correlatedAdsIds, correlatedTrackingInfo, deleteReason, deleteReasons, itemAdvertiser, itemCategory, itemFeature, itemFeatures, itemImage, itemURN, itemVisibilityOptions, keyValuePair, price, searchExtras, userAd, userAdStatistics, userAds };
//# sourceMappingURL=zod.js.map
